// extracted by mini-css-extract-plugin
export default {"tictactoegame":"baafa27b2ea618205a6d","gameinfo":"d1b90ac2b0c0ac32d140"};